import React from "react";
import PropTypes from "prop-types";
import CreatorPhoto from "../../assets/images/creator_photo.png";
import "./style.scss";
import { useTranslation } from "react-i18next";

export default function GameAuthor({
  className,
  imgClassName,
  photo = CreatorPhoto,
}) {
  GameAuthor.propTypes = {
    className: PropTypes.string,
    photo: PropTypes.any,
    imgClassName: PropTypes.string,
  };
  const { t } = useTranslation();
  const cls = ["creator"];
  const imgCls = ["creator__photo"];
  if (className) cls.push(className);
  if (imgClassName) imgCls.push(imgClassName);
  return (
    <div className={cls.join(" ")}>
      <img src={photo} alt="creator_photo" className={imgCls.join(" ")} />
      <div className="creator__info">
        <p className="creator__info__fio">{t("section_welcome.creator")}</p>
        <small className="creator__info__status">
          {t("section_welcome.creator_alias")}
        </small>
      </div>
    </div>
  );
}
